import { useEngineInstance } from '@surveycake/react-logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import {
  GoNextPageService,
  GoPageAndSubmitDisabledService,
  GoPrevPageService,
  useBeforeunload,
  useSubscribeEngineMessage
} from 'app/modules/survey';
import { Container, Footer } from 'app/shared/components';
import React, { useMemo } from 'react';
import Content from './Content';
import SurveyFooter from './Footer';
import { useInitialEngine } from './hooks';

function Survey() {
  const engine = useEngineInstance();
  const multiplePages = useMemo(() => engine.getSurveyData().multiplePages, [
    engine
  ]);
  const surveyConfig = useSurveyConfig();
  const legaltext = surveyConfig.translation.legaltext || surveyConfig.data.legaltext;

  useSubscribeEngineMessage();
  useBeforeunload(surveyConfig);

  const inner = (
    <div>
      <Container>
        <Content />
        <SurveyFooter />
      </Container>
      <Footer legalText={legaltext} />
    </div>
  );

  if (!multiplePages) {
    return inner;
  }

  /**
   * Only provide page service on multiple pages mode.
   */
  return (
    <GoPrevPageService>
      <GoNextPageService>{inner}</GoNextPageService>
    </GoPrevPageService>
  );
}

export default function SurveyContainer() {
  const isInitialed = useInitialEngine();

  if (!isInitialed) {
    return null;
  }

  return (
    <GoPageAndSubmitDisabledService>
      <Survey />
    </GoPageAndSubmitDisabledService>
  );
}
